module.exports = __webpack_public_path__ + "img/spin_off_s.071c05f3.png";